var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalAssetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "digital_assets") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vttp0w3h6a",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon base"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(9 2)",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#vttp0w3h6a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "layer-group-solid",
    d: "M68.328.834a8.741 8.741 0 0 1 7.344 0l34.156 15.783a3.758 3.758 0 0 1 0 6.813L75.672 39.212a8.741 8.741 0 0 1-7.344 0L34.172 23.43a3.758 3.758 0 0 1 0-6.813zm33.188 31.941 8.313 3.844a3.758 3.758 0 0 1 0 6.813L75.672 59.214a8.741 8.741 0 0 1-7.344 0L34.172 43.432a3.758 3.758 0 0 1 0-6.813l8.313-3.844 23.75 10.97a13.764 13.764 0 0 0 11.531 0l23.75-10.97zm-23.75 30.971 23.75-10.97 8.313 3.844a3.758 3.758 0 0 1 0 6.813L75.672 79.216a8.741 8.741 0 0 1-7.344 0L34.172 63.434a3.758 3.758 0 0 1 0-6.813l8.313-3.844 23.75 10.97a13.764 13.764 0 0 0 11.531-.001z",
    transform: "translate(-23 5.98)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalAssetsIcon);
export default __webpack_public_path__ + "static/media/digital_assets_icon.f1adee4f1c984380660cef9c517ba9bf.svg";
export { ForwardRef as ReactComponent };